import { Page, Text, View, Font, Image, Document, StyleSheet, Link } from "@react-pdf/renderer";
import PoppinsRegular from "../assets/fonts/poppins/Poppins-Regular.ttf";
import PoppinsMedium from "../assets/fonts/poppins/Poppins-Medium.ttf";
import PoppinsSemiBold from "../assets/fonts/poppins/Poppins-SemiBold.ttf";
import PoppinsBold from "../assets/fonts/poppins/Poppins-Bold.ttf";
import { addHttpsPrefix, replaceValueInDataSet } from "../utils";
import Logo from "../assets/images/logo.png";
import { BUYER_STATES_FILTERS, INVESTOR_LOGO_HOST, LOGO_DEV_PUBLIC_KEY } from "../constant";

Font.register({
  family: "PoppinsBold",
  format: "truetype",
  src: PoppinsBold,
});
Font.register({
  family: "PoppinsSemiBold",
  format: "truetype",
  src: PoppinsSemiBold,
});
Font.register({
  family: "PoppinsMedium",
  format: "truetype",
  src: PoppinsMedium,
});
Font.register({
  family: "PoppinsRegular",
  format: "truetype",
  src: PoppinsRegular,
});
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    padding: "30px 20px 0",
  },
  title: {
    textAlign: "center",
    color: "#000",
    fontSize: 20,
    fontFamily: "PoppinsSemiBold",
    marginTop: 10,
    marginBottom: 10,
  },
  logobox: {
    width: 50,
    height: 65,
    position: "absolute",
    left: 10,
    top: 10,
  },
  section: {
    padding: "15px 0 10px",
    borderBottom: "1px solid #c5c5c5",
  },
  secTitle: {
    fontSize: 13,
    fontFamily: "PoppinsSemiBold",
  },
  secLogo: {
    width: 20,
    marginLeft: 5,
    marginRight: 10,
    maxHeight: 25,
  },
  link: {
    fontSize: 8,
    fontFamily: "PoppinsRegular",
    color: "#605BFF",
    marginBottom: 2,
    marginTop: 2,
  },
  description: {
    fontSize: 8,
    fontFamily: "PoppinsRegular",
  },
  subTitle: {
    marginTop: 10,
    fontSize: 8,
    fontFamily: "PoppinsSemiBold",
  },
  subDescription: {
    marginTop: 3,
    fontSize: 7,
    fontFamily: "PoppinsRegular",
    color: "#868ea8",
  },
  spacer: {
    padding: 5,
  },
  subHeading: {
    fontSize: 9,
    fontFamily: "PoppinsSemiBold",
  },
  listitem: {
    position: "relative",
    paddingLeft: 10,
    display: "flex",
  },
  listbullet: {
    position: "absolute",
    left: 0,
    fontSize: 11,
    color: "#605BFF",
  },
  listtext: {
    fontSize: 8,
    fontFamily: "PoppinsRegular",
  },
  topHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    textAlign: "left",
  },
  statusTxt: {
    textTransform: "capitalize",
    padding: "3px 18px",
    marginLeft: 15,
    color: "#fff",
    fontSize: 8,
    fontFamily: "PoppinsRegular",
    borderRadius: 2,
  },
  secRow: {
    display: "flex",
    flexDirection: "row",
  },
  secCol: {
    width: "30%",
    paddingRight: 10,
  },
  titleHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  detailBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  detailBoxText: {
    fontSize: 7,
    fontFamily: "PoppinsRegular",
  },
  seperator: {
    marginHorizontal: 5,
    color: "#c5c5c5",
    fontSize: 8,
  },
  tagRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 6,
    marginBottom: 2,
    gap: 3,
  },
  tagPill: {
    backgroundColor: "#E8E5FF",
    color: "#605BFF",
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 4,
    fontSize: 7,
    marginRight: 4,
    marginBottom: 6,
    fontFamily: "PoppinsMedium",
  },
  titleBox: {
    flex: 1,
  },
  industryHeading: {
    fontSize: 13,
    fontFamily: "PoppinsSemiBold",
    color: "#4338ca",
    marginTop: 15,
    marginBottom: 4,
    paddingBottom: 3,
    borderBottomWidth: 1,
    borderBottomColor: "#a5b4fc",
    borderBottomStyle: "solid",
  },
  tierBadgeBase: {
    fontSize: 7,
    fontFamily: "PoppinsMedium",
    marginLeft: 8,
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 3,
  },
  tocSection: {
    marginTop: 2,
    marginBottom: 6,
    paddingBottom: 6,
    borderBottomWidth: 1,
    borderBottomColor: "#e2e8f0",
    borderBottomStyle: "solid",
  },
  tocHeading: {
    fontSize: 8,
    fontFamily: "PoppinsSemiBold",
    color: "#475569",
    marginBottom: 6,
  },
  tocRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
  },
  tocLink: {
    backgroundColor: "#f1f5f9",
    borderWidth: 1,
    borderColor: "#cbd5e1",
    borderStyle: "solid",
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
    marginRight: 6,
    marginBottom: 6,
  },
  tocLinkText: {
    fontSize: 7,
    fontFamily: "PoppinsMedium",
    color: "#605BFF",
  },
  /** Florence buyer cards — tighter than generic `section` to fit more per page */
  florenceCard: {
    paddingTop: 6,
    paddingBottom: 6,
    borderBottomWidth: 1,
    borderBottomColor: "#c5c5c5",
    borderBottomStyle: "solid",
  },
  florenceTitleHeader: {
    marginBottom: 2,
  },
  florenceLink: {
    fontSize: 6,
    fontFamily: "PoppinsRegular",
    color: "#605BFF",
    marginTop: 1,
    marginBottom: 5,
  },
  florenceMetaLine: {
    fontSize: 8,
    fontFamily: "PoppinsRegular",
    lineHeight: 1.35,
    marginBottom: 6,
  },
  florenceMetaLineLast: {
    fontSize: 8,
    fontFamily: "PoppinsRegular",
    lineHeight: 1.35,
    marginBottom: 0,
  },
  /** Field labels — darker than body, distinct from purple industry titles */
  florenceInlineLabel: {
    fontSize: 7,
    fontFamily: "PoppinsSemiBold",
    color: "#0f172a",
  },
  /** Paragraph / value text — muted so headings and labels stand out */
  florenceMetaValue: {
    fontSize: 8,
    fontFamily: "PoppinsRegular",
    color: "#64748b",
  },
  florenceCardIndex: {
    fontSize: 11,
    fontFamily: "PoppinsSemiBold",
    color: "#000",
  },
  florenceCompanyName: {
    fontSize: 13,
    fontFamily: "PoppinsSemiBold",
    color: "#111827",
  },
  florenceDetailMuted: {
    fontSize: 7,
    fontFamily: "PoppinsRegular",
    color: "#64748b",
  },
  florenceTagRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    marginTop: 1,
    marginBottom: 4,
  },
  florenceTagLabel: {
    fontSize: 7,
    fontFamily: "PoppinsSemiBold",
    color: "#0f172a",
    marginRight: 4,
    marginBottom: 2,
  },
  florenceTagPill: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    fontSize: 6,
    marginRight: 3,
    marginBottom: 2,
  },
  florenceTierBadge: {
    paddingVertical: 1,
    paddingHorizontal: 5,
  },
});

/** Aligns with investor list: backend strings "Diamond", "Tier 1", … or legacy 1–4 */
export const getTierLabelForPdf = (tier) => {
  if (tier == null || tier === "") return "";
  const s = String(tier).trim();
  if (["Diamond", "Tier 1", "Tier 2", "Tier 3"].includes(s)) return s;
  const n = Number(tier);
  if (n === 1) return "Diamond";
  if (n === 2) return "Tier 1";
  if (n === 3) return "Tier 2";
  if (n === 4) return "Tier 3";
  return s || `Tier ${tier}`;
};

/** Tier pill colors — mirrors `.investor-tier-icon-wrap` in global.scss (gold / emerald / blue / slate) */
const getTierBadgePdfStyle = (tier) => {
  const label = getTierLabelForPdf(tier);
  const map = {
    Diamond: { backgroundColor: "#f59e0b", color: "#ffffff" },
    "Tier 1": { backgroundColor: "#059669", color: "#ffffff" },
    "Tier 2": { backgroundColor: "#2563eb", color: "#ffffff" },
    "Tier 3": { backgroundColor: "#64748b", color: "#ffffff" },
  };
  return map[label] ?? { backgroundColor: "#94a3b8", color: "#ffffff" };
};

/** Higher LLM rank is better; missing ranks sort last. */
const getBuyerLlmRank = (item) => item?.programx_output?.rank ?? item?.rank;

const getLlmRankSortValue = (rank) => {
  if (rank == null || rank === "" || rank === "-") return Number.NEGATIVE_INFINITY;
  const n = Number(rank);
  return Number.isFinite(n) ? n : Number.NEGATIVE_INFINITY;
};

export const sortBuyersByLlmRank = (items) =>
  [...(items || [])].sort(
    (a, b) => getLlmRankSortValue(getBuyerLlmRank(b)) - getLlmRankSortValue(getBuyerLlmRank(a)),
  );

const sortBuyersForPdfSection = sortBuyersByLlmRank;

const getIndustryCaseInsensitiveKey = (value) => String(value ?? "").trim().toLowerCase();

const toTitleCaseWords = (value) =>
  String(value).replace(/\b([a-z])/g, (match) => match.toUpperCase());

const normalizeIndustryLabelForPdf = (value, preferredLabelsByKey = new Map()) => {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return "";

  const key = getIndustryCaseInsensitiveKey(trimmed);
  const preferred = preferredLabelsByKey.get(key);
  if (preferred) return preferred;

  // Auto-normalize fully-lowercase labels to title case (e.g. "strategic fit" => "Strategic Fit").
  if (trimmed === trimmed.toLowerCase()) return toTitleCaseWords(trimmed);
  return trimmed;
};

const normalizeIndustryValuesForPdf = (value, preferredLabelsByKey = new Map()) => {
  if (!value) return [];
  const arr = String(value)
    .split(/[,|]/)
    .map((item) => item.trim())
    .filter(Boolean);
  return [...new Set(arr.map((item) => normalizeIndustryLabelForPdf(item, preferredLabelsByKey)))];
};

const INDUSTRY_OTHER_KEY = "__other__";

/**
 * Groups Florence buyers by preferred industry (user_preferred_industry_segmentation).
 * Order: company questionnaire industries first, then remaining names A–Z, then "Other".
 * Companies sorted by LLM rank within each group.
 * If there are no named industry sections, returns a flat list (no "Other" section flow).
 */
export const buildFlorenceIndustrySections = (processedBuyers, preferredIndustryOrder = []) => {
  const buckets = new Map();
  const preferredLabelsByKey = new Map();
  for (const ind of Array.isArray(preferredIndustryOrder) ? preferredIndustryOrder : []) {
    const label = String(ind ?? "").trim();
    if (!label) continue;
    const key = getIndustryCaseInsensitiveKey(label);
    if (!preferredLabelsByKey.has(key)) preferredLabelsByKey.set(key, label);
  }

  const addToBucket = (industry, item) => {
    if (!buckets.has(industry)) buckets.set(industry, []);
    buckets.get(industry).push(item);
  };

  for (const item of processedBuyers) {
    const raw = item?.programx_output?.user_preferred_industry_segmentation;
    const industries = normalizeIndustryValuesForPdf(raw, preferredLabelsByKey);
    if (industries.length === 0) {
      addToBucket(INDUSTRY_OTHER_KEY, item);
    } else {
      for (const ind of industries) {
        addToBucket(ind, item);
      }
    }
  }

  for (const [, arr] of buckets.entries()) {
    const seen = new Set();
    const deduped = [];
    for (const item of arr) {
      const id = `${item?.programx_output?.url ?? ""}|${item?.programx_output?.company_name ?? ""}`;
      if (seen.has(id)) continue;
      seen.add(id);
      deduped.push(item);
    }
    arr.length = 0;
    arr.push(...sortBuyersForPdfSection(deduped));
  }

  const preferred = Array.isArray(preferredIndustryOrder)
    ? preferredIndustryOrder
        .map((ind) => normalizeIndustryLabelForPdf(ind, preferredLabelsByKey))
        .filter(Boolean)
    : [];
  const used = new Set();
  const sections = [];

  for (const ind of preferred) {
    if (!buckets.has(ind) || buckets.get(ind).length === 0) continue;
    sections.push({ industry: ind, items: buckets.get(ind) });
    used.add(ind);
  }

  const rest = [...buckets.keys()]
    .filter((k) => k !== INDUSTRY_OTHER_KEY && !used.has(k) && buckets.get(k).length > 0)
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  for (const ind of rest) {
    sections.push({ industry: ind, items: buckets.get(ind) });
  }

  // No real industry groups — keep a flat PDF (avoid a lone "Other" section).
  if (sections.length === 0) {
    const flatItems = sortBuyersForPdfSection(processedBuyers || []);
    return flatItems.length ? [{ industry: null, items: flatItems }] : [];
  }

  if (buckets.has(INDUSTRY_OTHER_KEY) && buckets.get(INDUSTRY_OTHER_KEY).length > 0) {
    sections.push({ industry: "Other", items: buckets.get(INDUSTRY_OTHER_KEY) });
  }

  return sections;
};

const FlorenceBuyerCard = ({ item, index }) => {
  const tierLabel = getTierLabelForPdf(item?.programx_output?.tier);
  const prefIndustries = normalizeIndustryValuesForPdf(
    item?.programx_output?.user_preferred_industry_segmentation,
  ).map((x) => replaceValueInDataSet(x));
  const prefIndustryLine = prefIndustries.length ? prefIndustries.join(", ") : "-";

  const rawTags = item?.programx_output?.tags;
  const tagsArr = !rawTags
    ? []
    : Array.isArray(rawTags)
      ? rawTags.filter(Boolean).map((t) => replaceValueInDataSet(String(t).trim()))
      : String(rawTags)
          .split(",")
          .map((t) => replaceValueInDataSet(t.trim()))
          .filter(Boolean);

  return (
    <View style={styles.florenceCard} wrap={false}>
      <View style={[styles.titleHeader, styles.florenceTitleHeader]}>
        <View style={styles.titleBox}>
          <View style={styles.topHeader}>
            <Text style={styles.florenceCardIndex}>{index + 1} -</Text>
            <Image src={item?.logoSrc} style={styles.secLogo} />
            <Text style={styles.florenceCompanyName}>
              {item?.programx_output?.company_name
                ? replaceValueInDataSet(item?.programx_output?.company_name)
                : "-"}
            </Text>
            {tierLabel ? (
              <Text
                style={[
                  styles.tierBadgeBase,
                  styles.florenceTierBadge,
                  getTierBadgePdfStyle(item?.programx_output?.tier),
                ]}
              >
                {tierLabel}
              </Text>
            ) : null}
          </View>
        </View>
        <View style={styles.detailBox}>
          {(() => {
            const type = item?.programx_output?.type
              ? replaceValueInDataSet(item?.programx_output?.type)
              : null;

            const state = item?.programx_output?.us_state_full
              ? replaceValueInDataSet(item?.programx_output?.us_state_full)
              : null;

            const country = item?.programx_output?.country
              ? replaceValueInDataSet(item?.programx_output?.country)
              : null;

            const placeParts = [state, country].filter(Boolean).join(", ");

            return (
              <Text style={styles.florenceDetailMuted}>
                {type}
                {type && placeParts ? " • " : ""}
                {placeParts}
              </Text>
            );
          })()}
        </View>
      </View>
      <Text style={styles.florenceLink}>
        {item?.programx_output?.url ? addHttpsPrefix(item?.programx_output?.url) : "-"}
      </Text>
      <Text style={styles.florenceMetaLine}>
        <Text style={styles.florenceInlineLabel}>Preferred industry: </Text>
        <Text style={styles.florenceMetaValue}>{prefIndustryLine}</Text>
      </Text>
      <Text style={styles.florenceMetaLine}>
        <Text style={styles.florenceInlineLabel}>Description: </Text>
        <Text style={styles.florenceMetaValue}>
          {item?.programx_output?.description
            ? replaceValueInDataSet(item?.programx_output?.description)
            : "-"}
        </Text>
      </Text>
      {tagsArr.length > 0 ? (
        <View style={styles.florenceTagRow}>
          <Text style={styles.florenceTagLabel}>Tags: </Text>
          {tagsArr.map((tag, i) => (
            <Text key={i} style={[styles.tagPill, styles.florenceTagPill]}>
              {tag}
            </Text>
          ))}
        </View>
      ) : null}
      <Text style={styles.florenceMetaLineLast}>
        <Text style={styles.florenceInlineLabel}>Reasons For Target: </Text>
        <Text style={styles.florenceMetaValue}>
          {item?.programx_output?.ai_description
            ? replaceValueInDataSet(item?.programx_output?.ai_description)
            : "-"}
        </Text>
      </Text>
    </View>
  );
};

/** Min space (pt) required below an industry heading; otherwise the heading moves to the next page */
const FLORENCE_INDUSTRY_HEADING_MIN_PRESENCE = 220;

/** Florence / AI recommendation buyer list PDF — grouped by preferred industry, tier on each card */
export const BuyerPDF = ({
  data = [],
  sections: sectionsProp,
  title = "Rothchild Eye Institute Investors",
}) => {
  const sections =
    sectionsProp ??
    (data.length ? [{ industry: null, items: data }] : []);

  const showIndustryToc =
    sectionsProp != null &&
    sections.some((s) => s.industry != null && s.items && s.items.length > 0);

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        <Image src={Logo} style={styles.logobox} />
        <Text style={styles.title}>{title}</Text>
        {showIndustryToc ? (
          <View style={styles.tocSection} wrap={false}>
            <Text style={styles.tocHeading}>Jump to industry</Text>
            <View style={styles.tocRow}>
              {sections.map((section, sIdx) =>
                section.industry != null && section.items?.length > 0 ? (
                  <Link key={sIdx} src={`#fl-ind-${sIdx}`} style={styles.tocLink}>
                    <Text style={styles.tocLinkText}>{section.industry}</Text>
                  </Link>
                ) : null,
              )}
            </View>
          </View>
        ) : null}
        {sections.map((section, sIdx) => (
          <View key={`${section.industry ?? "flat"}-${sIdx}`} break={sIdx > 0}>
            {section.industry != null ? (
              <View id={`fl-ind-${sIdx}`} minPresenceAhead={FLORENCE_INDUSTRY_HEADING_MIN_PRESENCE}>
                <Text style={styles.industryHeading}>{section.industry}</Text>
              </View>
            ) : null}
            {section.items.map((item, index) => (
              <FlorenceBuyerCard
                key={`${item?.programx_output?.url ?? index}-${index}`}
                item={item}
                index={index}
              />
            ))}
          </View>
        ))}
      </Page>
    </Document>
  );
};

export const LeadsPDF = ({ data = [], logo, company = "Rothchild Eye Institute" }) => {
  const generateStatusColor = (status) => {
    let statusColor = "#D0BBFE";
    if (status.toLowerCase() === "communicating") statusColor = "#5B93FF";
    if (status.toLowerCase() === "contacted") statusColor = "#DD97E9";

    return statusColor;
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Image src={Logo} style={styles.logobox} />
        <Text style={styles.title}>{company} Leads</Text>
        {/* <Image
          src={{
            uri: `${pdfHeaderImage}?cachebuster=${new Date().getTime()}`,
            method: "GET",
            headers: { "Cache-Control": "no-cache" },
            body: "",
            headers: {},

            // uri: "https://d3ethiri6v3lef.cloudfront.net/101+Mobility.png?not-from-cache-please2",
            // method: "GET",
            // headers: { "Access-Control-Allow-Origin": "*" },
          }}
          style={styles.logobox}
        /> */}

        {data.map((item, index) => (
          <View style={styles.section} key={index} wrap={false}>
            <View style={styles.topHeader}>
              <Text style={styles.secTitle}>{index + 1} -</Text>
              <Image src={INVESTOR_LOGO_HOST + item.url + `?token=${LOGO_DEV_PUBLIC_KEY}`} style={styles.secLogo} />
              <Text style={styles.secTitle}>
                {item?.lead_name ? replaceValueInDataSet(item?.lead_name) : "-"}
              </Text>
              <Text
                style={[
                  styles.statusTxt,
                  { backgroundColor: generateStatusColor(item?.status) },
                ]}
              >
                {item?.status ? replaceValueInDataSet(item?.status) : "-"}
              </Text>
            </View>

            <Text style={styles.link}>{item?.url ? addHttpsPrefix(item?.url) : "-"}</Text>
            <View style={styles.secRow}>
              <View style={styles.secCol}>
                <Text style={styles.subTitle}>State</Text>
                <Text style={styles.subDescription}>
                  {item?.state ? replaceValueInDataSet(item?.state) : "-"}
                </Text>
              </View>
              <View style={styles.secCol}>
                <Text style={styles.subTitle}>Country</Text>
                <Text style={styles.subDescription}>
                  {item?.country ? replaceValueInDataSet(item?.country) : "-"}
                </Text>
              </View>
            </View>

            {item?.user_notes && (
              <>
                <View style={styles.spacer} />
                <Text style={styles.subHeading}>User Notes</Text>
                <Text style={styles.listtext}>{item?.user_notes}</Text>
              </>
            )}
          </View>
        ))}
      </Page>
    </Document>
  );
};

export const InvestorsPDF = ({ data = [] }) => {
  return (
    <Document>
      {/* {data.length >= 1 && ( */}
      <Page size="A4" style={styles.page}>
        <Image src={Logo} style={styles.logobox} />
        <Text style={styles.title}>Investors</Text>
        {data.map((item, index) => (
          <View style={styles.section} key={index} wrap={false}>
            <Text style={styles.secTitle}>
              {index + 1} -{" "}
              {item?.company_name ? replaceValueInDataSet(item?.company_name) : "-"}
            </Text>
            <Text style={styles.link}>{item?.url ? addHttpsPrefix(item?.url) : "-"}</Text>
            <Text style={styles.description}>
              {item?.description ? replaceValueInDataSet(item?.description) : "-"}
            </Text>
            <View style={styles.secRow}>
              <View style={styles.secCol}>
                <Text style={styles.subTitle}>Type</Text>
                <Text style={styles.subDescription}>
                  {item?.type ? replaceValueInDataSet(item?.type) : "-"}
                </Text>
              </View>
              <View style={styles.secCol}>
                <Text style={styles.subTitle}>NAICS Industry</Text>
                <Text style={styles.subDescription}>
                  {item?.naics_six_digit_industry
                    ? replaceValueInDataSet(item?.naics_six_digit_industry)
                    : "-"}
                </Text>
              </View>
            </View>
            <View style={styles.secRow}>
              <View style={styles.secCol}>
                <Text style={styles.subTitle}>State</Text>
                <Text style={styles.subDescription}>
                  {item?.us_state_full ? replaceValueInDataSet(item?.us_state_full) : "-"}
                </Text>
              </View>
              <View style={styles.secCol}>
                <Text style={styles.subTitle}>Country</Text>
                <Text style={styles.subDescription}>
                  {item?.country ? replaceValueInDataSet(item?.country) : "-"}
                </Text>
              </View>
            </View>

            <View style={styles.secRow}>
              <View style={styles.secCol}>
                <Text style={styles.subTitle}>Broad Specialty</Text>
                <Text style={styles.subDescription}>
                  {item?.broad_specialty
                    ? replaceValueInDataSet(item?.broad_specialty)
                    : "-"}
                </Text>
              </View>
              <View style={styles.secCol}>
                <Text style={styles.subTitle}>Narrow Specialty</Text>
                <Text style={styles.subDescription}>
                  {item?.narrow_specialty
                    ? replaceValueInDataSet(item?.narrow_specialty)
                    : "-"}
                </Text>
              </View>
            </View>

            <View style={styles.secRow}>
              <View style={styles.secCol}>
                <Text style={styles.subTitle}>Preferred Ebitda (mm)</Text>
                <Text style={styles.subDescription}>
                  {item?.preferred_ebitda
                    ? replaceValueInDataSet(item?.preferred_ebitda)
                    : "-"}
                </Text>
              </View>
              <View style={styles.secCol}>
                <Text style={styles.subTitle}>Preferred Revenue (mm)</Text>
                <Text style={styles.subDescription}>
                  {item?.preferred_revenue
                    ? replaceValueInDataSet(item?.preferred_revenue)
                    : "-"}
                </Text>
              </View>
            </View>

            <View style={styles.secRow}>
              <View style={styles.secCol}>
                <Text style={styles.subTitle}>Preferred EV (mm)</Text>
                <Text style={styles.subDescription}>
                  {item?.preferred_ev ? replaceValueInDataSet(item?.preferred_ev) : "-"}
                </Text>
              </View>
              <View style={styles.secCol}>
                <Text style={styles.subTitle}>Equity Investment (mm)</Text>
                <Text style={styles.subDescription}>
                  {item?.typical_equity_investments
                    ? replaceValueInDataSet(item?.typical_equity_investments)
                    : "-"}
                </Text>
              </View>
            </View>
          </View>
        ))}
      </Page>
      {/* )} */}
    </Document>
  );
};
